import { categoryParams } from "../../../node-category";

/**
 * Source de vérité unique du fil d'Ariane.
 *
 * Consommée à la fois par le rendu visible du composant `Breadcrumbs` et par le
 * JSON-LD `BreadcrumbList` qu'il émet, pour que les deux ne puissent pas
 * diverger — Google demande que le fil balisé corresponde au fil affiché.
 *
 * Remonte la chaîne des catégories parentes depuis la catégorie donnée et
 * renvoie le fil ordonné de la racine vers la feuille :
 *   [{ strapiId, name, url }, …]
 *
 * `url` porte le préfixe `/categorie-produit/` (via `categoryParams.urlPrefix`) :
 * c'est l'URL canonique d'une catégorie, celle qui ne part pas en 301.
 *
 * `categories` : les nœuds de `allStrapiCategory` ({ strapiId, name, slug,
 * strapiParent }). `categoryId` : l'identifiant Strapi de la catégorie de départ.
 */
export function buildBreadcrumbTrail(categories, categoryId) {
  const trail = [];
  const seen = new Set();
  let current = (categories || []).find((c) => c.strapiId === categoryId);

  // `seen` protège d'une boucle infinie si une catégorie était son propre ancêtre.
  while (current && !seen.has(current.strapiId)) {
    seen.add(current.strapiId);
    trail.unshift({
      strapiId: current.strapiId,
      name: current.name,
      url: `${categoryParams.urlPrefix}${current.slug}`,
    });
    const parentId = current.strapiParent && current.strapiParent.id;
    current = parentId ? categories.find((c) => c.strapiId === parentId) : null;
  }

  return trail;
}

/** Identifiant Strapi d'une catégorie, quelle que soit sa provenance. */
export function categoryStrapiId(category) {
  if (!category) return null;
  return category.strapiId || category.id || null;
}
